import { render, staticRenderFns } from "./GovSecretariat.vue?vue&type=template&id=4bd271a7&scoped=true"
import script from "./GovSecretariat.vue?vue&type=script&lang=js"
export * from "./GovSecretariat.vue?vue&type=script&lang=js"
import style0 from "./GovSecretariat.vue?vue&type=style&index=0&id=4bd271a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd271a7",
  null
  
)

export default component.exports